<template>
    <div class="row">
      <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <scanned-voter-upload-form @save="getUploads()" v-if="showForm" :model="selected"></scanned-voter-upload-form>
          </div>
        </div>
  
      </el-drawer>
  
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">Manage Uploads</div>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
              <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-button plain type="primary" size="small" class="ml-2" @click="getUploads">Refresh <i class="fa fa-refresh"></i></el-button>
            <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="uploads" style="width: 100%" :row-class-name="getRowClass">
          
              <el-table-column :min-width="120"  class-name="td-actions" label="File">
                <template slot-scope="props">
                    <a :href="props.row.public_path" target="_blank">DOWNLOAD</a><br>
                    <span>Uploaded By: {{ props.row.user.name }}</span>
                    <div>{{ $moment(props.row.created_at).format('MMM D, YYYY h:mm A') }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120"  class-name="td-actions" label="Remarks">
                <template slot-scope="props">
                   <div v-html="formattedRemarks(props.row.remarks)"></div>
                </template>
              </el-table-column>
              
              <el-table-column :min-width="120"  class-name="td-actions" label="Status">
                <template slot-scope="props">
                  <el-tag v-if="props.row.status == 0" type="primary">New</el-tag>
                  <el-tag v-if="props.row.status == 1" type="">In progress</el-tag>
                  <el-tag v-if="props.row.status == 2" type="success">Completed</el-tag>
                  <el-tag v-if="props.row.status == 3" type="error">Error</el-tag>
                </template>
              </el-table-column>

    
              <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
                <template slot-scope="props">
                  <el-button type="default" link @click="handleReset(props.row)" size="mini">
                   Reset <i class="fa fa-refresh"></i>
                </el-button>
                <confirm-delete @onClick="handleDelete(props.row)" :label="'Delete'"></confirm-delete>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Found {{ pagination.total }} data</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import { BarangayImport } from '@/resources/barangay_import'
  import ConfirmDelete from '../../Common/ConfirmDelete.vue'
    import ScannedVoterUploadForm from './ScannedVoterUploadForm.vue'
import { ScannedVoterUpload } from '../../../resources/scanned_voter_upload';
  
  export default {
    components: { ConfirmDelete, ScannedVoterUploadForm },
    data() {
        return {
        loading: false,
        showForm: false,
        uploads: [],
        selected: null,
        perPageOptions: [5, 10, 15],
        pagination: {
          perPage: 999,
          currentPage: 1,
          total: 0
        },
        term: null,
        rowLoading: {},
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getUploads()
        }
      },
      'pagination.perPage': function () {
        if (this.pagination.currentPage == 1) {
          this.getUploads()
        } else {
          this.pagination.currentPage = 1
        }
      },
      'pagination.currentPage': function () {
        this.getUploads()
      }
    },
    created: function () {
      this.getUploads()
    },
    methods: {
      getRowClass({ row }) {
        return this.rowLoading[row.id] ? 'loading-row' : '';
      },
        formattedRemarks(remarks) {
        // Replace newline characters with <br> for HTML rendering
        return remarks.replace(/\n/g, '<br>');
        },
      handleEdit(model) {
        this.showForm = true
        this.selected = Object.assign({}, model)
      },
      handleClose() {
        this.showDelete = false
        this.showForm = false
      },
      handleForm() {
        this.showForm = true
        this.selected = null
      },
      handleReset(model){
        this.$set(this.rowLoading, model.id, true); // start loading this row

        ScannedVoterUpload.update(model.id, {reset: 1})
            .then(result => {
            this.$notify({
                type: 'success',
                title: "Success",
                text: 'Saved',
            });
            this.getImports()
            })
            .catch(() => {

            }).finally(() => {
              this.$set(this.rowLoading, model.id, false); // stop loading this row
            })
      },
      handleDelete(model) {
        this.loading = true
  
        ScannedVoterUpload.delete(model.id)
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Upload has been removed',
            });
            this.getUploads()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
      getUploads() {
        this.handleClose()
        let params = { term: this.term, status: this.status, page: this.pagination.currentPage, per_page: this.pagination.perPage }
        this.loading = true
        ScannedVoterUpload.get(params)
          .then(result => {
            if (result.data.scanned_voter_uploads)
              this.uploads = result.data.scanned_voter_uploads
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch uploads',
            });
  
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style lang="scss"></style>
  